"use client"

import { TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { ArrowUpDown } from "lucide-react"
import type { SortField } from "@/utils/applicantsTable/customTypes"

interface TableHeaderProps {
  onSort: (field: SortField) => void
}

export function ApplicantsTableHeader({ onSort }: TableHeaderProps) {
  return (
    <TableHeader>
      <TableRow className="bg-gray-800 text-white border-b-0">
        <TableHead
          className="w-[150px] cursor-pointer hover:bg-gray-700 transition-colors"
          onClick={() => onSort("name")}
        >
          <div className="flex items-center">
            Name
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </div>
        </TableHead>
        <TableHead
          className="w-[200px] cursor-pointer hover:bg-gray-700 transition-colors"
          onClick={() => onSort("email")}
        >
          <div className="flex items-center">
            Email
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </div>
        </TableHead>
        <TableHead className="w-[100px]">Qualified</TableHead>
        <TableHead
          className="w-[150px] cursor-pointer hover:bg-gray-700 transition-colors"
          onClick={() => onSort("category")}
        >
          <div className="flex items-center">
            Category
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </div>
        </TableHead>
        <TableHead className="w-[200px]">Note</TableHead>
        <TableHead className="w-[100px]">Resume</TableHead>
        <TableHead className="w-[120px]">Profile</TableHead>
        <TableHead className="w-[100px]">Actions</TableHead>
      </TableRow>
    </TableHeader>
  )
}
